import { render } from "./OtpCheck.vue?vue&type=template&id=4fc9e539&scoped=true"
import script from "./OtpCheck.vue?vue&type=script&lang=js"
export * from "./OtpCheck.vue?vue&type=script&lang=js"

import "./OtpCheck.vue?vue&type=style&index=0&id=4fc9e539&scoped=true&lang=css"
import "./OtpCheck.vue?vue&type=style&index=1&id=4fc9e539&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc9e539"]])

export default __exports__